import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';

/**
 * 反映予約確認モーダルコンポーネント
 */
export default {
    template: '#modal_reserve_deploy_confirm_template',
    data() {
        return {
        };
    },
    mixins: [commonMixin, modalMixin],
    emits: ['close', 'add-deploy-reservation', 'deploy-at-once'],
    methods: {
        // 閉じるボタンクリックを親に通知
        closeModal: function () {
            this.$emit('close');
            this.close();
        },
        // 追加ボタンクリックを親に通知
        emitAddDeployReservation: function () {
            this.$emit('add-deploy-reservation');
        },
        // 今すぐ反映するクリックを親に通知
        emitDeployAtOnce: function () {
            this.$emit('deploy-at-once');
        },
    }
};
